import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";
import Image from "../../assets/images/logo.png";

const Invoice_Bill = () => {
  const [getData, setGetData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { bill_no } = useParams();
  const hasPrinted = useRef(false);

  // Function to convert number to words
  const numberToWords = (num) => {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion"];

    if (num === 0) return "Zero";

    const getWords = (n, level) => {
      if (n === 0) return "";
      let str = "";
      if (n >= 100) {
        str += `${units[Math.floor(n / 100)]} Hundred `;
        n %= 100;
      }
      if (n >= 11 && n <= 19) {
        str += `${teens[n - 10]} `;
      } else if (n >= 10) {
        str += `${tens[Math.floor(n / 10)]} `;
        n %= 10;
      }
      if (n > 0 && n < 10) {
        str += `${units[n]} `;
      }
      return str + thousands[level];
    };

    let words = "";
    let level = 0;
    while (num > 0) {
      const chunk = num % 1000;
      if (chunk > 0) {
        words = `${getWords(chunk, level)} ${words}`.trim();
      }
      num = Math.floor(num / 1000);
      level++;
    }
    return words + " Rupees Only";
  };

  // Fetch data from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Apiurl}/generalbill_no/${bill_no}`);
      console.log("Bill Response Data:", response.data);

      // Handle array or object response
      let billData = response.data;
      if (Array.isArray(response.data)) {
        billData = response.data.find((bill) => bill.bill_no === bill_no);
      }

      if (billData && Object.keys(billData).length > 0) {
        setGetData(billData);
      } else {
        setError("No data found for the provided bill number.");
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError("Failed to fetch invoice data. Please try again later.");
      setLoading(false);
    }
  };

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Fetch data when bill_no changes
  useEffect(() => {
    fetchData();
  }, [bill_no]);

  // Trigger print when data is loaded
  useEffect(() => {
    if (getData && !hasPrinted.current) {
      hasPrinted.current = true;
      window.print();
    }
  }, [getData]);

  // Back to previous page
  const handleBack = () => {
    navigate("/bill/general");
  };

  // Calculate totals
  const calculateTotals = () => {
    if (!getData?.service_list) return { subTotal: 0, tax: 0, total: 0 };

    // console.log("the getData.service_list in the calculate totals is :",getData.service_list);

    const subTotal = getData.service_list.reduce(
      (sum, item) =>
        sum + Number(item.basePrice) * (Number(item.quantity) || 1),
      0,
    );
    const tax = getData.service_list.reduce(
      (sum, item) =>
        sum +
        (Number(item.basePrice) *
          (Number(item.quantity) || 1) *
          Number(item.tax_percentage)) /
          100,
      0,
    );
    const total = subTotal + tax;

    // console.log("the total tax and subtotal is :",total, subTotal, tax);
    return {
      subTotal: Math.round(subTotal * 100) / 100,
      tax: Math.round(tax * 100) / 100,
      total: Math.round(total * 100) / 100,
      // subTotal: 11,
      // tax: 22,
      // total: 33,
    };
  };

  const totals = calculateTotals();

  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center mt-5 text-danger">{error}</div>;
  }

  if (!getData) {
    return (
      <div className="text-center mt-5">
        No data found for bill number {bill_no}
      </div>
    );
  }

  // Calculate total tax percentage for display (SGST + CGST)
  const totalTaxPercentage = getData.service_list.reduce(
    (acc, item) => acc + Number(item.tax_percentage || 0),
    0,
  );

  // Calculate received amount and balance
  // const receivedAmount = Math.round(
  //   getData.payment?.[0]?.amount || getData.advance_amount || 0
  // );

  // const receivedAmount = Math.round(
  //   parseInt(getData.payment?.[0]?.amount || 0) +
  //     parseInt(getData.cash || 0) +
  //     parseInt(getData.advance_amount || 0)
  // );

  let receivedAmount;
  if (getData.cash > 0 && getData.advance_amount > 0) {
    // receivedAmount = Math.round(parseFloat(getData.payment?.[0]?.amount || 0));
    // receivedAmount = Math.round(
    //   parseFloat(getData.payment?.[0]?.amount) -
    //     Number(getData.advance_amount) || 0
    // );

    receivedAmount = Math.round(
      parseFloat(getData.net_total) - Number(getData.advance_amount) || 0,
    );
  } else {
    receivedAmount = Math.round(
      parseFloat(getData.payment?.[0]?.amount || 0) +
        parseFloat(getData.cash || 0),
      // parseFloat(getData.advance_amount || 0)
    );
  }

  console.log("Recived Amount: ", receivedAmount);

  // const advanceamount =
  //   getData.advance_amount && Number(getData.advance_amount) !== 0
  //     ? Math.round(Number(getData.advance_amount))
  //     : Math.round(getData.net_total) - Math.round(getData.cash);

  // const advanceamount =
  //   Number(getData.advance_amount) > 0
  //     ? Math.round(Number(getData.advance_amount))
  //     : Number(getData.net_total) > 0 && Number(getData.cash) > 0
  //     ? Math.round(Number(getData.net_total) - Number(getData.cash))
  //     : 0;

  // const advanceamount =
  //   Number(getData.advance_amount) > 0
  //     ? Math.round(Number(getData.advance_amount))
  //     : Number(getData.net_total) > 0 && Number(getData.cash) > 0
  //     ? Math.round(Number(getData.net_total) - Number(getData.cash))
  //     : getData.payment?.[0]?.amount
  //     ? Math.round(
  //         Number(getData.net_total) - Number(getData.payment[0].amount)
  //       )
  //     : 0;

  const advanceamount = getData.advance_amount ? getData.advance_amount : 0;

  const receivedbalance = Math.round(getData.payment?.[0]?.balance);

  return (
    <>
      <div className="d-flex justify-content-between mb-2 d-print-none mt-2 mx-5">
        <button className="btn btn-secondary btn-sm" onClick={handleBack}>
          Back
        </button>
      </div>

      {/* // Add this div BEFORE your main bill div inside the return statement */}
      {/* <div
        className="blank-page"
        style={{
          width: "148mm",
          minHeight: "210mm",
          display: "block",
        }}
      /> */}

      <div className="blank-page" />

      <div className="d-flex justify-content-center bg-light mt-1">
        <div
          className="bg-white px-3 pt-2"
          style={{
            width: "148mm",
            minHeight: "210mm",
            maxHeight: "210mm",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div>
              <h6 className="fw-bold mb-1">WE CARE</h6>
              <h6 className="fw-bold mb-1">AUTHORIZED SERVICE CENTER</h6>
              <div className="mb-1" style={{ fontSize: "11px" }}>
                <i className="fa-solid fa-home"></i>
                <span className="ms-1">
                  No 113 & 114, Light House Complex, <br />
                  <span className="mb-1 ms-4">
                    Omalur Main Road, 4 Roads, Salem-636009
                  </span>
                </span>
              </div>
              <div style={{ fontSize: "11px" }}>
                <i className="fa-solid fa-mobile"></i>
                &nbsp;+91-9123514823 &nbsp;+91 8124909380
              </div>
              <div style={{ fontSize: "11px" }}>
                <i className="fa-solid fa-envelope"></i>
                &nbsp;wecare.slm22@gmail.com
              </div>
              <div style={{ fontSize: "11px" }}>
                <b>GSTIN:</b>
                &nbsp;33FCHPS5099M1ZQ
              </div>
            </div>
            <div>
              <img
                src={Image}
                alt="logo"
                className="img-fluid"
                style={{ maxHeight: "60px" }}
              />
            </div>
          </div>
          <div className="text-center text-primary">
            <h5 className="fw-bold">TAX INVOICE</h5>
          </div>

          {/* Bill To / Invoice Info */}
          <div className="d-flex justify-content-between mb-1">
            <div className="col-6" style={{ fontSize: "12px" }}>
              <h6 className="fw-bold mb-0">Bill To</h6>
              <p className="mb-0">{getData.name}</p>
              <p className="mb-0">{getData.mobile_no}</p>
              {getData.gstin && getData.gstin !== "0" && (
                <p className="mb-0">
                  <b>GSTIN:</b> {getData.gstin}
                </p>
              )}
              <p className="mb-0">
                <b>Brand:</b> {getData.brand} &nbsp;&nbsp;
                <b>Model:</b> {getData.model}
              </p>
              <p className="mb-0">
                <b>IMEI:</b> {getData.imei}
              </p>
            </div>
            <div className="col-5" style={{ fontSize: "12px" }}>
              <h6 className="fw-bold mb-0">Invoice Details</h6>
              <div className="d-flex justify-content-between">
                <span>Invoice No:</span>
                <b>{getData.bill_no}</b>
              </div>
              <div className="d-flex justify-content-between">
                <span>Date:</span>
                <span>{formatDate(getData.date)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Billed By:</span>
                <span>{getData.bill_staff || "N/A"}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Technician:</span>
                <span>{getData.technician || "N/A"}</span>
              </div>
            </div>
          </div>

          {/* Product Table */}
          <div className="table-responsive" style={{ fontSize: "12px" }}>
            <table
              className="table"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead className="table-primary border">
                <tr>
                  <th
                    className="border border-dark border-end-0 p-1"
                    style={{ width: "5%" }}
                  >
                    #
                  </th>
                  <th
                    className="border border-dark border-end-0 border-start-0 p-1"
                    style={{ width: "50%" }}
                  >
                    Description
                  </th>
                  <th
                    className="border border-dark border-end-0 border-start-0 p-1"
                    style={{ width: "10%" }}
                  >
                    Qty
                  </th>
                  <th
                    className="border border-dark border-end-0 border-start-0 p-1"
                    style={{ width: "15%" }}
                  >
                    Rate
                  </th>
                  <th
                    className="border border-dark border-end-0 border-start-0 p-1"
                    style={{ width: "15%" }}
                  >
                    GST
                  </th>
                  <th
                    className="border border-dark border-start-0 text-end p-1"
                    style={{ width: "30%" }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {getData.service_list.map((item, index) => (
                  <tr key={index}>
                    <td className="border border-dark border-bottom-0 border-end-0 p-1">
                      {index + 1}
                    </td>
                    <td className="border border-dark border-start-0 border-end-0 p-1">
                      {item.serviceName}
                      <br />
                      <small className="fw-bold">HSN: {item.hsnCode}</small>
                    </td>
                    <td className="border border-dark border-start-0 border-end-0 p-1">
                      {item.quantity}
                    </td>
                    <td className="border border-dark border-start-0 border-end-0 p-1">
                      ₹ {Math.round(Number(item.basePrice))}
                    </td>
                    <td className="border border-dark border-start-0 border-end-0 p-1">
                      {item.tax_percentage}%
                    </td>
                    <td
                      className="border border-dark border-start-0 text-end p-1"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {Math.round(
                        Number(item.basePrice) *
                          (Number(item.quantity) || 1) *
                          (1 + Number(item.tax_percentage) / 100),
                      ).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr className="fw-bold" style={{ width: "100%" }}>
                  <td className="border border-dark border-end-0 p-1"></td>
                  <td className="text-end pe-3 border border-dark border-start-0 border-end-0 p-1">
                    Total
                  </td>
                  <td className="border border-dark border-start-0 border-end-0 p-1">
                    {getData.service_list.reduce(
                      (sum, item) => sum + Number(item.quantity),
                      0,
                    )}
                  </td>
                  <td className="border border-dark border-start-0 border-end-0 p-1"></td>
                  <td className="border border-dark border-start-0 border-end-0 p-1">
                    ₹ {totals.tax}
                  </td>
                  <td
                    className="border border-dark border-start-0 border-top-0 d-flex p-1 gap-1 text-end"
                    style={{ width: "100%" }}
                  >
                    <div>₹</div>
                    <div>{Number(Math.round(totals.total)).toFixed(2)}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Bank & Amount Section */}
          <div
            className="d-flex justify-content-between"
            style={{ marginTop: "-10px" }}
          >
            <div style={{ width: "55%" }}>
              <div className="mt-0">
                <h6 className="fw-bold" style={{ fontSize: "12px" }}>
                  Amount In Words
                </h6>
                <div className="fst-italic" style={{ fontSize: "12px" }}>
                  {numberToWords(totals.total)}
                </div>
              </div>
            </div>
            <div className="mt-0" style={{ width: "40%" }}>
              <table className="table table-sm table-borderless">
                <tbody style={{ fontSize: "12px", lineHeight: "10px" }}>
                  <tr>
                    <td>Sub Total</td>
                    <td className="text-end">₹ {totals.subTotal}</td>
                  </tr>
                  <tr>
                    {/* <td>SGST @{totalTaxPercentage / 2}%</td> */}
                    <td>SGST @9%</td>
                    <td className="text-end">₹ {Math.round(totals.tax / 2)}</td>
                  </tr>
                  <tr>
                    {/* <td>CGST @{totalTaxPercentage / 2}%</td> */}
                    <td>CGST @9%</td>
                    <td className="text-end">₹ {Math.round(totals.tax / 2)}</td>
                  </tr>
                  <tr className="table-primary fw-bold">
                    <td>Total</td>
                    <td className="text-end">
                      ₹ {Math.round(totals.total).toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td>Pay Type</td>
                    <td className="text-end">
                      <b>{getData.Paytype || "N/A"}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Advance </td>
                    <td className="text-end">₹ {advanceamount || 0}</td>
                  </tr>
                  {receivedAmount > 0 && (
                    <tr>
                      <td>Received</td>
                      <td className="text-end">₹ {receivedAmount}</td>
                    </tr>
                  )}
                  <tr>
                    <td>Balance</td>
                    <td className="text-end">₹ {receivedbalance}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer */}
          <div
            className="d-flex justify-content-between"
            style={{ fontSize: "12px", marginTop: "-8px" }}
          >
            <div>
              <h6 className="fw-bold" style={{ fontSize: "12px" }}>
                Terms And Conditions
              </h6>
              <div style={{ marginTop: "-7px" }}>
                Thank you for doing business with us.
              </div>
            </div>
            <div className="text-end">
              <div className="text-center">
                <p style={{ fontSize: "12px" }}>
                  For: WE CARE AUTHORIZED SERVICE CENTER
                </p>
              </div>
              <div className="fw-bold pt-3" style={{ fontSize: "12px" }}>
                Authorized Signatory
              </div>
            </div>
          </div>

          <p
            className="justify-content-center d-flex align-items-end"
            style={{ fontSize: "10px" }}
          >
            --Developed By Aalantechsoft-Salem.--
          </p>
        </div>
      </div>

      {/* <style>
        {`
          @media print {
            @page {
              size: A5 portrait;
              margin: 5mm;
            }

            html, body {
              height: 100%;
              overflow: hidden !important;
              margin: 0 !important;
              padding: 0 !important;
            }

            .d-flex.justify-content-center.bg-light {
              max-width: 148mm !important;
              max-height: 210mm !important;
              padding: 3mm !important;
              overflow: hidden !important;
              page-break-inside: avoid !important;
              page-break-after: always !important;
              box-sizing: border-box;
            }

            .btn, .d-print-none {
              display: none !important;
            }

            .navbar, .sidebar, .nav, [class*="nav"], [class*="sidebar"] {
              display: none !important;
            }
          }
        `}
      </style> */}

      {/* <style>
        {`
         @media print {
  @page {
    size: A5 portrait;
    margin: 5mm;
  }

  
  .blank-page {
    display: block !important;
    width: 148mm;
    height: 210mm;
    page-break-after: always !important;
  }

 
  .d-flex.justify-content-center.bg-light {
    max-width: 148mm !important;
    max-height: 210mm !important;
    padding: 3mm !important;
    overflow: hidden !important;
    page-break-inside: avoid !important;
    box-sizing: border-box;
  }
}
        `}
      </style> */}

      <style>
        {`
         /* ✅ Add this OUTSIDE @media print — hides it on screen */
.blank-page {
  display: none;
}

@media print {
  @page {
    size: A5 portrait;
    margin: 5mm;
  }

  /* ✅ Shows only during print */
  .blank-page {
    display: block !important;
    width: 148mm;
    height: 210mm;
    page-break-after: always !important;
  }

  .d-flex.justify-content-center.bg-light {
    max-width: 148mm !important;
    max-height: 210mm !important;
    padding: 3mm !important;
    overflow: hidden !important;
    page-break-inside: avoid !important;
    box-sizing: border-box;
  }

  .btn, .d-print-none {
    display: none !important;
  }

  .navbar, .sidebar, .nav, [class*="nav"], [class*="sidebar"] {
    display: none !important;
  }
}
        `}
      </style>
    </>
  );
};

// table_footer
// width: 173mm;

export default Invoice_Bill;
